import { combineReducers } from "redux";
import contactReducer from "./reducer";

const reducer = combineReducers({
  contactReducer,
});

export default reducer;
